import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-gestiones-burointerno',
  templateUrl: './gestiones-burointerno.component.html',
  styleUrls: ['./gestiones-burointerno.component.scss']
})
export class GestionesBurointernoComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any
  @Input() participante: any
  @Input() datacliente: any
  constructor() { 
    setTimeout(() => {
    }
    , 200);
  }

  ngOnInit(): void {

  }
  selectedtab(tab) {
    this.selecttab.emit(tab)
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
  isNegative(item) {
    let boolNegative = false
    if (Number(item) < 0) {
      boolNegative=true
    }
    return boolNegative
  }
}
